import SvgIcon from "@/components/SvgIcon";
import EmptyContent from "@/components/common/EmptyContent";
import downloadPluging from "@/utils/initDownload";
import { player } from "@/config";
import { defaultTitle } from "@/config";
import dayjs from 'dayjs'

export default {
  install(Vue) {
    Vue.prototype.$appTitle = defaultTitle;
    Vue.prototype.downloadPluging = downloadPluging;
    Vue.prototype.$player = player;
    Vue.prototype.$dayjs = dayjs;
    // 用于模拟考套题音频监听事件
    Vue.prototype.HSKVoice = function (key, newVal) {
      //这个key就是我们要监听的那个key
      if (key === "HSKVoice") {
        // 创建一个StorageEvent事件
        let newStorageEvent = document.createEvent("StorageEvent");
        const storage = {
          setItem: function (k, val) {
            //这里可以灵活更改local和session
            localStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent("HSKVoice", false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent);
          },
        };
        return storage.setItem(key, newVal);
      }
    };
    // 全局组件
    Vue.component("svg-icon", SvgIcon);
    Vue.component("empty-content", EmptyContent);
  },
};
